declare const USE_HOSTNAME: string;

const _USE_HOSTNAME = USE_HOSTNAME;

export {_USE_HOSTNAME as USE_HOSTNAME};